import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Laura', 'Roberto', 'Sofía', 'Ana', 'Diego', 'Claudia', 'Martín', 'Gabriela'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'San Juan', 'Tucumán', 'Santa Fe'];
export function PurchaseNotification() {
  const [notification, setNotification] = useState<{
    name: string;
    city: string;
  } | null>(null);
  useEffect(() => {
    const showNotification = () => {
      const name = NAMES[Math.floor(Math.random() * NAMES.length)];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      setNotification({
        name,
        city
      });
      // Hide after 4 seconds
      setTimeout(() => {
        setNotification(null);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showNotification, 15000);
    // Loop
    const interval = setInterval(() => {
      // Random interval between 15s and 45s
      const randomDelay = Math.random() * (45000 - 15000) + 15000;
      setTimeout(showNotification, randomDelay);
    }, 45000); // Base interval
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-85">
      {notification && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: 0
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 bg-white p-4 rounded-xl shadow-2xl border-l-4 border-[#4a7c2c] max-w-xs flex items-center gap-3" data-id="element-86">
          <div className="bg-[#e8f5e9] p-2 rounded-full shrink-0" data-id="element-87">
            <CheckCircle className="w-5 h-5 text-[#4a7c2c]" data-id="element-88" />
          </div>
          <div data-id="element-89">
            <p className="text-sm font-bold text-[#1a1a1a]" data-id="element-90">Nueva compra</p>
            <p className="text-xs text-[#666666]" data-id="element-91">
              🌱{' '}
              <span className="font-medium text-[#2d5016]" data-id="element-92">
                {notification.name}
              </span>{' '}
              de {notification.city} acaba de comprar la guía
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}